import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useMatchAtLeastOneRole } from 'utils/hooks';
import { RoleNames } from 'utils/constants';
import NetworkForm from './NetworkForm';
import NetworksTable from './NetworksTable';

const Networks = () => {
    const userIsStandardServicer = useMatchAtLeastOneRole([RoleNames.SERVICER_STANDARD]);

    return (
        <Routes>
            {!userIsStandardServicer && <Route path="create" element={<NetworkForm />} />}
            {!userIsStandardServicer && <Route path="edit/:id" element={<NetworkForm />} />}
            <Route index element={<NetworksTable />} />
            <Route path="*" element={<Navigate to="/networks" replace />} />
        </Routes>
    );
};

export default Networks;
